// Shared UI constants.

// Base URL for build.amazon.com; append a buildRequestId to link to a specific build.
export const BUILD_LINK = 'https://build.amazon.com/';
